import React, { useMemo } from "react"
import { FlatList, StyleSheet, Text, View } from "react-native"
import { RefreshControl } from "react-native-web-refresh-control"

import Base from "../../base"
import OrdersListItem from "./OrdersListItem"

export default function OrdersList(props) {
  let orders =
    props.orders.length > 0
      ? props.orders
      : [
          {
            empty: true,
            reference: "1",
            isStatusEditable: props.isStatusEditable,
          },
        ]
  let subtitle = props.historic ? "" : "Destination:"
  if (props.orders.length === 0) {
    subtitle = "Awaiting Orders"
  }

  function renderItem(order, i) {
    return (
      <OrdersListItem
        key={i}
        order={order.item}
        onPress={props.onPress}
        isStatusEditable={!!props.isStatusEditable}
      />
    )
  }

  const listPadding = useMemo(() => {
    let paddingHorizontal = Base.constants.hmargin.md
    if (props.size.isMobile) {
      paddingHorizontal = Base.constants.hmargin.sm
    }

    return { paddingHorizontal }
  }, [props])

  return (
    <FlatList
      refreshControl={
        <RefreshControl
          refreshing={props.isRefreshing}
          onRefresh={props.onRefresh}
        />
      }
      ListHeaderComponent={() => (
        <View style={styles.header}>
          <Text
            style={[
              props.size.isMobile ? Base.styles.title_sm : Base.styles.title_md,
              styles.title,
            ]}
          >
            {props.title}
          </Text>
          <Text style={styles.subtitle}>{subtitle}</Text>
        </View>
      )}
      ListFooterComponent={() => <View style={styles.footer} />}
      showsVerticalScrollIndicator={false}
      style={[styles.list, listPadding]}
      data={orders}
      keyExtractor={order => order.reference.toString()}
      renderItem={renderItem}
    />
  )
}

const styles = StyleSheet.create({
  title: {
    marginVertical: 16,
  },

  subtitle: {
    fontFamily: Base.fonts.appRegular,
    fontSize: 13,
  },

  footer: {
    height: 100,
  },

  header: {
    alignSelf: "center",
    width: "100%",
    maxWidth: 400,
  },

  list: { width: "100%" },
})
